import config from 'app-config'
import { combineReducers } from 'redux'
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'
import { createStoreEvents, reduxHookMiddleware } from 'sb-redux-hook'
import { createStore, combineReducers as redactionCombineReducers } from 'redaction'

import localReducers from 'redux/reducers'
import routingReducer from 'redux/routing/reducer'


const enhancers = [
  /client|dev/.test(config.webpack) && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (v) => v,
]

// add new reducers here
const _createStore = (initialState) => {
  const storeEvents = createStoreEvents(localReducers)

  const middleware = [
    routerMiddleware(browserHistory),
    reduxHookMiddleware(storeEvents),
  ]

  const store = createStore({
    enhancers,
    middleware,
    initialState,
    reducers: {
      ...redactionCombineReducers(localReducers),
      // news: combineReducers(redactionCombineReducers(localReducers.news)),
      voting: combineReducers(redactionCombineReducers(localReducers.voting)),
      marketplace: combineReducers(redactionCombineReducers(localReducers.marketplace)),
      lscSchedules: combineReducers(redactionCombineReducers(localReducers.lscSchedules)),
      lscTransportControl: combineReducers(redactionCombineReducers(localReducers.lscTransportControl)),
      emergencyAlert: combineReducers(redactionCombineReducers(localReducers.emergencyAlert)),
      routing: routingReducer,
    },
  })

  return { store, storeEvents }
}


export default _createStore
